import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {InputQuestion} from '../models/inputField';
import {FormControl} from '@angular/forms';
import * as _ from 'lodash';
//import {Observable} from "rxjs/Observable";

declare var $: any;

export interface UIFormTextInputStyleConfig {
  size: any,
  color: any
}

export interface UIFormTextInputStyles {
  label: string;
  text: string;
  inputBar: string;
}

export interface UIFormTextInputOption {
  autocorrect: string;
  autocapitalize: string;
  spellcheck: string;
  cssStyles: UIFormTextInputStyles;
}

@Component({
    selector: 'app-forms-classic-textinput',
    template: `


        <ng-container *ngTemplateOutlet="isClassic && classicTRef"></ng-container>

		<ng-template #classicTRef>
			<div class="form-group">
				<label for="input"
					   *ngIf="label || formItem.label"
					   [class]="inputLabelAttr">
					{{label || formItem.label}}
				</label>
				<input
					type="{{formItem.type}}"
					class="form-control rounded-0 form-control-md"
					[class]="inputAttr"
					[ngClass]="inputColor"
					[readonly]="formItem.readonly || inputReadOnly"
					[formControl]="controlItem"
					pattern="{{pattern || formItem.pattern}}"
					id="input"
                    placeholder="{{placeholder}}"
                    (keyup)="onChange()"
                    (change)="onChange()"
                    value="{{formItem.value}}"
                    min="{{formItem.min}}"
                    max="{{formItem.max}}"
                    >
				<small class="form-text text-muted" *ngIf="helperText">{{helperText}}</small>
            </div>
		</ng-template>

    `
})
export class TextInputClassicComponent implements OnInit, AfterViewInit {
    @ViewChild('input') inputEl: any;

    @Input() formItem: InputQuestion;

    @Input() float: boolean;

    @Input() inline: boolean;

	@Input() classic: boolean;

    //@Input() readonly: boolean = false;

    @Input() icon: boolean;

    @Output() selected: EventEmitter<any> = new EventEmitter<any>();

    @Output() valueChangeEmitter: EventEmitter<any> = new EventEmitter<any>();

    @Output() jInputElEm: EventEmitter<any> = new EventEmitter<any>();

    @Output() inputElEm: EventEmitter<any> = new EventEmitter<any>();

    @Input() inputAttr: string;

    @Input() inputValue: string;

    @Input() inputColor: string;

    @Input() inputReadOnly: boolean;

    @Input() inputLabelAttr: string;

    @Input() inputBarAttr: string;

	@Input() helperText: boolean;

    @Input() showErrorText: boolean = true;

    @Input() hide: boolean = false;

    @Input() focus: boolean = false;

    @Input() pattern: any;

    @Input() label: any;

    @Input() placeholder: any;

    @Input() options: UIFormTextInputOption = <UIFormTextInputOption>{ };

    itemError: boolean = false;

    mask: any = false;

    controlItem: FormControl = new FormControl({value: null, disabled: false});

    constructor(private element: ElementRef) {}

    get isFloat() {
      return this.float;
    }
    get isInline() {
        return this.inline;
    }

    get isClassic(){
    	return this.classic
	}

    ngOnInit(){

        if(this.inputValue)
          this.controlItem.setValue(this.inputValue);

        if(!_.isEmpty(this.formItem.value))
          this.controlItem.setValue(this.formItem.value);

        if(!_.isEmpty(this.formItem.validators))
          this.controlItem.setValidators(this.formItem.validators);

        if(this.formItem.mask) this.mask = this.formItem.mask;

        this.selected.emit(this.controlItem);

        if (!this.showErrorText)
            this.formItem.error = "";

    }

    isControlItemError(){
      if(this.controlItem.valid || !this.controlItem.touched || this.controlItem.errors.pattern){
        return false
      } else {
        return true
      }
    }

    get jEl(){return $(this.element.nativeElement)}

    get jInputEl(){return this.jEl.find('#' + 'input')}

    ngAfterViewInit(){
      //if(this.focus)  this.jInputEl.focus();
      //if(this.float) this.jInputEl.attr('formControlFloat', true);
      //this.jInputElEm.emit(this.jInputEl);
    }

    onChange() {
        this.valueChangeEmitter.emit(this.controlItem.value);
    }
}
